import { useContext } from "react";

import TableContext from "context/table/tableContext";
import { TABLE_NAMES, useMediaQueries } from "shared";

import CompanyDetails from "./CompanyDetails";
import DesktopDetails from "./DesktopDetails";
import DeviceDetails from "./DeviceDetails";
import DeviceGroupDetails from "./DeviceGroupDetails";
import LicenseDetails from "./LicenseDetails";
import MobileDetails from "./MobileDetails";
import TaskGroupDetails from "./TaskGroupDetails";
import { TableDetailsProps } from "./types";
import UserDetails from "./UserDetails";

const TableDetails = ({ heights, setDefaultHeigth }: TableDetailsProps) => {
    const { tableName } = useContext(TableContext);

    const { toMd } = useMediaQueries();

    const renderContent = () => {
        switch (tableName) {
            case TABLE_NAMES.Devices:
                return <DeviceDetails />;
            case TABLE_NAMES.TaskGroups:
                return <TaskGroupDetails />;
            case TABLE_NAMES.DeviceGroups:
                return <DeviceGroupDetails />;
            case TABLE_NAMES.Companies:
                return <CompanyDetails />;
            case TABLE_NAMES.Users:
                return <UserDetails />;
            case TABLE_NAMES.DesktopLicenses:
                return <LicenseDetails />;
            default:
                return <div></div>;
        }
    };

    return toMd ? (
        <MobileDetails>{renderContent()}</MobileDetails>
    ) : (
        <DesktopDetails heights={heights} setDefaultHeigth={setDefaultHeigth}>
            {renderContent()}
        </DesktopDetails>
    );
};

export default TableDetails;
